import React from "react";

/** Standard screen header: title on the left, optional action(s) on the right. */
const PageHeader = ({ title, children }) => (
  <div className="flex items-center justify-between gap-3 px-4 py-3">
    <h1 className="text-xl font-bold text-slate-800">{title}</h1>
    {children && <div className="flex items-center gap-4">{children}</div>}
  </div>
);

export default PageHeader;
